module.exports = __webpack_public_path__ + "img/balcon.ba6bfef0.svg";